import { CCol, CFormCheck, CRow } from "@coreui/react";
import React from "react";
import { random } from "src/util/MathUtil";

export default class MultiSelectionCheckbox extends React.Component {

    constructor(props) {
        super(props);

        this.randomNumber1 = random(100, 999);
        this.randomNumber2 = random(100, 999);

        this.state = {
            list: props.list
        }
    }

    handleChecks(list) {

        for (var i=0;i<list.length;i++) {

            if (Array.isArray(list[i].subList)) {

                var isAllChecked = true;
                
                for (var j=0;j<Object.keys(list[i].subList).length;j++) {

                    if (!list[i].subList[j].checked) {

                        isAllChecked = false;
                        break;
                    }
                }
                list[i].allChecked = isAllChecked;
            }
        }

        this.randomNumber1 = random(100, 999);
        this.randomNumber2 = random(100, 999);
        this.setState({
            list: list
        });
    }

    handleItemCheck(index, subIndex) {

        var list = this.state.list;
        list[index].subList[subIndex].checked = !list[index].subList[subIndex].checked;
        this.props.onUpdate([{item: list[index], subIndex: subIndex}]);

        this.handleChecks(list);
    }

    handleAllCheck(index) {

        var list = this.state.list;

        var listToUpdate = [];

        if (list[index].subList && list[index].subList.length) {

            for (var i=0;i<list[index].subList.length;i++) {

                if (list[index].allChecked) {

                    if (list[index].subList[i].checked) {
                        list[index].subList[i].checked = false;
                        listToUpdate.push({item: list[index], subIndex: i});
                    }
                }
                else {

                    if (!list[index].subList[i].checked) {
                        list[index].subList[i].checked = true;
                        listToUpdate.push({item: list[index], subIndex: i});
                    }
                }
            }
        }

        this.props.onUpdate(listToUpdate);

        list[index].allChecked = !list[index].allChecked;

        this.randomNumber1 = random(100, 999);
        this.randomNumber2 = random(100, 999);
        this.setState({
            list: list
        });
    }

    render() {

        return(

            <CRow>
                <CCol md="12">
                    {
                        this.state.list.map((object, index) => {

                            return(

                                <div className="multiSelectionCheckBoxHolder" key={"mainDiv"+index}>
                                    <h6>
                                        {object.text}
                                    </h6>
                                    <div className="multiSelectionCheckBoxContainer">

                                        {
                                            object.subList && object.subList.length > 1 ?
                                                <CFormCheck 
                                                    key={index+"_"+(object.allChecked ? 1: 0)+"_"+this.randomNumber1}
                                                    label="Select All" 
                                                    defaultChecked={object.allChecked} 
                                                    onChange={() => {this.handleAllCheck(index)}} />
                                            : null
                                        }
                                        
                                        {
                                            object.subList ?
                                                object.subList.map((subObject, subIndex) => {

                                                    return(
                                                        <CFormCheck 
                                                            key={subIndex+"_"+(subObject.checked ? 1: 0)+"_"+this.randomNumber2}
                                                            label={subObject.text} 
                                                            defaultChecked={subObject.checked}
                                                            onChange={() => {this.handleItemCheck(index, subIndex)}} />
                                                    );
                                                })
                                            : null
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </CCol>
            </CRow>
        )
    }
}